import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { LoginRouteGuard } from "./login-route.guard";
import { AppServicesModule } from "./app-services.module";
import { MainLayoutComponent } from './layout/main-layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DeviceListComponent } from './devices/device-list/device-list.component';
import { LocationListComponent } from './locations/location-list/location-list.component';
import { DeviceEditComponent } from './devices/device-edit/device-edit.component';
import { LocationEditComponent } from './locations/location-edit/location-edit.component';
import { LoginComponent } from './auth/login/login.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { DeviceDetailComponent } from './devices/device-detail/device-detail.component';
import { DeviceControllerEditComponent } from './devices/device-controller-edit/device-controller-edit.component';
import { IpComponent } from './devices/ip/ip.component';
import { UserEditComponent } from './user/user-edit/user-edit.component';
import { SearchComponent } from './search/search.component';
import { OrganizationListComponent } from './organization/organization-list/organization-list.component';
import { OrganizationUsersComponent } from './organization/organization-users/organization-users.component';
import { OrganizationEditComponent } from './organization/organization-edit/organization-edit.component';
import { OrganizationDetailComponent } from './organization/organization-detail/organization-detail.component';
import { NotificationComponent } from './shared/notification/notification.component';
import { SelectComponent } from './shared/select/select.component';
import { AdminComponent } from './admin/admin.component';
import { LoadingComponent } from './shared/loading/loading.component';
import { CheckPasswordDirective } from './shared/forms/password.directive';
import { SerialTerminalComponent } from './shared/serial-terminal/serial-terminal.component';
import { BulkDeviceEditComponent } from './shared/bulk-device-edit/bulk-device-edit.component';
import { IpDestinationPipe } from './shared/ip-destination.pipe';
import { MapComponent } from './dashboard/map/map.component';
import { PoorConnectionDevicesPipe } from './shared/poor-connection-devices.pipe';
import { OrgLocationFieldsComponent } from './shared/org-location-fields/org-location-fields.component';
import { LocationOrgFilterPipe } from './shared/location-org-filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    DeviceListComponent,
    LocationListComponent,
    DeviceEditComponent,
    LocationEditComponent,
    MainLayoutComponent,
    HeaderComponent,
    LoginComponent,
    SidebarComponent,
    DeviceDetailComponent,
    DeviceControllerEditComponent,
    IpComponent,
    UserEditComponent,
    SearchComponent,
    OrganizationListComponent,
    OrganizationUsersComponent,
    OrganizationEditComponent,
    OrganizationDetailComponent,
    NotificationComponent,
    SelectComponent,
    AdminComponent,
    LoadingComponent,
    CheckPasswordDirective,
    SerialTerminalComponent,
    BulkDeviceEditComponent,
    IpDestinationPipe,
    MapComponent,
    PoorConnectionDevicesPipe,
    OrgLocationFieldsComponent,
    LocationOrgFilterPipe
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    AppServicesModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgbModule,
    NgSelectModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
